module.exports = __webpack_public_path__ + "img/11.52452612.jpg";